export const AccordionGridHeader = ({
  columns,
  gridTemplateColumns,
}: {
  columns: { label: string; className?: string }[];
  gridTemplateColumns: string;
}) => (
  <div
    className="grid w-full items-center px-4 py-4 BookEZ_font_body_medium border-b BookEZ_accordion_border_color BookEZ_accordion_header_text_color BookEZ_accordion_header_color"
    style={{ gridTemplateColumns }}
  >
    {columns.map((col, idx) => (
      <div key={col.label + idx} className={col.className || ""}>
        {col.label}
      </div>
    ))}
  </div>
);
